var render, staticRenderFns
import script from "./processList.vue?vue&type=script&lang=js&"
export * from "./processList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4895b86",
  null
  
)

export default component.exports